import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { SoundProvider } from "./hooks";
import { BrowserRouter, Routes, Route } from "react-router-dom";

ReactDOM.render(
  <BrowserRouter>
    <Routes>
      <Route
        path="/"
        element={
          <SoundProvider>
            <Suspense fallback={null}>
              <App />
            </Suspense>
          </SoundProvider>
        }
      />
      <Route
        path="/outoftheboxbox"
        element={
          <SoundProvider>
            <Suspense fallback={null}>
              <App />
            </Suspense>
          </SoundProvider>
        }
      />
    </Routes>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
